import { render, staticRenderFns } from "./DataTablesHeaderColumnComponent.vue?vue&type=template&id=bc553180&"
import script from "./DataTablesHeaderColumnComponent.vue?vue&type=script&lang=js&"
export * from "./DataTablesHeaderColumnComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports